import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Typography,
} from "@mui/material";
import React, { useCallback } from "react";
import FetchHook from "../../../../Api/FetchHooks";
import { useState } from "react";
import { useEffect } from "react";
import PageLoader from "../../../../Components/PageLoader";
import TableComponent from "../../../../Components/TableComponent";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Page from "../../../../Components/Page";
import AddIcon from "@mui/icons-material/Add";
import AlertComponent from "../../../../Components/AlertComponent";
import ActionDialog from "../../../../Components/ActionDialog";
import { AllInbox } from "@mui/icons-material";
import ErrorDisplay from "../../../../Components/ErrorDisplay";
import UseServerTable from "../../../../Hooks/UseServerTable";
import { formatCurrencyV2, formatDate } from "../../../../utils/helpers";

const Guarantors = ({ _user }) => {
  const location = useLocation();
  const loggedInUser = useSelector((state) => state?.auth?.user);

  const [loading, response, request] = FetchHook();

  const [user, setUser] = useState(
    _user || location?.state?.user || loggedInUser,
  );
  const [data, setData] = useState([]);

  const [dialog, setDialog] = useState({
    open: false,
    type: null,
    label: null,
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const openDialog = (type, label) => setDialog({ open: true, type, label });
  const closeDialog = () => setDialog({ open: false, type: null, label: null });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  // const fetchGuarantors = useCallback(async () => {
  //   await request({
  //     url: `guarantorship?entity_id=${user.id}&type=other_members`,
  //   });
  // }, [user]);

  // useEffect(() => {
  //   fetchGuarantors();
  // }, [fetchGuarantors]);

  // useEffect(() => {
  //   if (response && response.status === 200 && response.data.StatusCode === 0) {
  //     setData(response.data.Data);
  //   }
  // }, [response]);

  const { gridProps, error, refresh } = UseServerTable({
    baseUrl: `guarantorship?entity_id=${user.id}&type=other_members`,
    onSuccess: (data) => {
      setData(data.Data);
    },
  });

  useEffect(() => {
    if (error) {
      setSnackbar({
        open: true,
        message: error.message,
        severity: error.severity,
      });
    }
  }, [error]);

  const columns = [
    {
      field: "id",
      headerName: "#",
      width: 180,
    },
    // {
    //   field: "asset_name",
    //   headerName: "Asset name",
    //   minWidth: 150,
    //   flex: 1,
    // },
    {
      field: "loan_id",
      headerName: "Loan Id",
      width: 180,
    },
    {
      field: "loan_name",
      headerName: "Loan Name",
      width: 150,
    },
    // {
    //   field: "loan_amount",
    //   headerName: "Loan amount",
    //   minWidth: 200,
    //   flex: 1,
    // },
    {
      field: "guarantorship_amount",
      headerName: "Requested amount",
      valueFormatter: (param) => formatCurrencyV2(param?.value),
    },
    {
      field: "guaranteered_amount",
      headerName: "Guaranteed amount",
      valueFormatter: (param) => formatCurrencyV2(param?.value),
    },
    {
      field: "guarantorship_amount_bal",
      headerName: "Guarantorship amount balance",
      width: 150,
      valueFormatter: (param) => formatCurrencyV2(param?.value),
    },
    // {
    //   field: "worthyness",
    //   headerName: "Worthyness",
    //   minWidth: 150,
    //   flex: 1,
    // },
    // {
    //   field: "description",
    //   headerName: "Description",
    //   minWidth: 200,
    //   flex: 1,
    // },
    {
      field: "status",
      headerName: "Status",
      renderCell: (params) => {
        if (params.row.status === 0) {
          return (
            <Chip label="pending" color="warning" sx={{ color: "white" }} />
          );
        } else if (params.row.status === 1) {
          return (
            <Chip label="accepted" color="success" sx={{ color: "white" }} />
          );
        } else if (params.row.status === 3) {
          return (
            <Chip label="rejected" color="error" sx={{ color: "white" }} />
          );
        } else if (params.row.status === 4) {
          return <Chip label="paid_off" color="info" sx={{ color: "white" }} />;
        } else if (params.row.status === 5) {
          return (
            <Chip label="recovered" color="info" sx={{ color: "white" }} />
          );
        }
      },
    },
    {
      field: "date_created",
      headerName: "Date created",
      width: 200,
      valueFormatter: (params) => formatDate(params?.value),
    },
    {
      field: "last_updated_on",
      headerName: "Last updated on",
      width: 200,
      valueFormatter: (params) => formatDate(params?.value),
    },
  ];

  return (
    <>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <ActionDialog
        open={dialog.open}
        onClose={closeDialog}
        dialogType={dialog.type}
        dialogLabel={dialog.label}
        user={user}
        onSuccess={refresh}
      />

      <Card>
        <CardHeader
          title={<Typography variant="h6">User Guarantors</Typography>}
          subheader={
            <Typography variant="subtitle1">
              Your have {data.length} guarantors
            </Typography>
          }
          // action={
          //   <Box display={"flex"}>
          //     {loggedInUser.role === "customer" && data.length <= 0 && (
          //       <Button
          //         variant="contained"
          //         startIcon={<AddIcon />}
          //         onClick={() =>
          //           openDialog("nominate_guarantor", "Nominate Guarantor Form")
          //         }
          //       >
          //         Nominate Guarantor
          //       </Button>
          //     )}
          //   </Box>
          // }
        />

        <CardContent>
          {data.length > 0 ? (
            <TableComponent data={data} columns={columns} {...gridProps} />
          ) : gridProps.loading ? (
            <PageLoader />
          ) : (
            <ErrorDisplay
              message="You have no guarantors!"
              icon={
                <AllInbox color="secondary" sx={{ mx: "auto", fontSize: 80 }} />
              }
            />
          )}
        </CardContent>
      </Card>
    </>
  );
};

export default Guarantors;
